'use strict';

var Sugar = require('sugar-core'),
    inflectPlurals = require('../inflections/var/inflectPlurals');

Sugar.String.defineInstance({

  'pluralize': function(str, num) {
    str = String(str);
    // Reminder that this pretty much holds true only for English.
    return num === 1 || str.length === 0 ? str : inflectPlurals('plural', str);
  }

});

module.exports = Sugar.String.pluralize;